<template>
  <div v-show="value" ref="drawer"
       class="fixed z-50 inset-0 bg-black bg-opacity-40 h-screen overflow-hidden"
       aria-labelledby="modal-title">
    <div class="h-full" @click="onCloseDrawer"/>
    <div>
      <transition name="slide">
        <div v-if="value" class="bg-white w-full rounded-t-lg bottom-0 fixed p-4 max-h-3/4 overflow-scroll"
             :class="{'slide-leave-to': startLeaveAnimation}">
          <div class="flex flex-row justify-between items-center text-eezeeGray-dark">
            <p class="font-bold text-2xl">{{title}}</p>
            <img class="inline-block" @click="onCloseDrawer"
                 src="../assets/cross.svg"
                 alt="Cancel" role="button"/>
          </div>
          <slot/>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import {disableBodyScroll, clearAllBodyScrollLocks} from 'body-scroll-lock';

export default {
  name: "ZBottomSheet",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    }
  },
  watch: {
    value(val) {
      if (val === true) {
        this.bsl.disableBodyScroll(this.$refs.drawer)
      }

      if (val === false) {
        this.bsl.clearAllBodyScrollLocks()
      }
    }
  },
  beforeDestroy() {
    this.bsl.clearAllBodyScrollLocks()
  },
  data() {
    return {
      bsl: {disableBodyScroll, clearAllBodyScrollLocks},
      startLeaveAnimation: false
    }
  },
  methods: {
    onCloseDrawer() {
      this.startLeaveAnimation = true
      setTimeout(() => {
        this.$emit('input', false)
        this.startLeaveAnimation = false
      }, 200)
    }
  }
}
</script>

<style scoped>
.slide-enter-active,
.slide-leave-active {
  transition: all 0.2s ease;
}

.slide-enter,
.slide-leave-to {
  transform: translateY(100%);
  transition: all 0.2s ease;
}
</style>